// @flow strict
import * as React from 'react';
import defaultTheme from './default-theme.js';
import nebraskaTheme from './themes/nebraska-theme.js';
import alaskaTheme from './themes/alaska-theme.js';
import { Partner } from './partner.js';
import maineTheme from './themes/maine-theme';

export type Theme = {
  getLogo: () => React.Node,
  getWelcomePanelOverrideStyle: () => string
};

export const loadThemeForPartner = (partner: ?Partner): Theme => {
  if(!partner) return defaultTheme;
  let returnVal;
  switch(partner) {
    case Partner.Nebraska:
      returnVal = nebraskaTheme;
      break;
    case Partner.Alaska:
      returnVal = alaskaTheme;
      break;
    case Partner.Maine:
      returnVal = maineTheme;
      break;
    default:
      returnVal = defaultTheme;
  }
  return returnVal;
};